import {
  Configuration,
  RedirectRequest,
  SilentRequest,
  AccountInfo,
} from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    // Full directory URL
    authority: import.meta.env.VITE_MSAL_AUTHORITY,
    knownAuthorities: [import.meta.env.VITE_MSAL_DOMAIN],
    // Full redirect URL, in form of http://localhost:8080/auth-callback
    redirectUri: `${import.meta.env.VITE_APP_BASE_URI}/auth-callback`,
    // We need to disable this feature because it is already handled by react-admin, and would otherwise conflict
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};


const rolesPermissionMap: {[roleId: string]: string} = {
  "a8a24807-b521-4fc0-b5dc-7ce99ee3fdd9": "user",
  "3a6285fb-5bd2-478e-b67d-a82b4565aad0": "admin",
};


export const getPermissionsFromAccount = async (account: AccountInfo | null) => {
  //console.log('getPermissionsFromAccount:', account);
  const roles = account?.idTokenClaims?.roles ?? [];
  return roles.map((role) => rolesPermissionMap[role]);
};

export const getIdentityFromAccount = async (account: AccountInfo | null) => {
  //console.log('getIdentityFromAccount:', account);
  return {
    id: account?.localAccountId,
    fullName: account?.name,
  };
};

export const loginRequest: RedirectRequest = {
  scopes: ["https://estatetime.onmicrosoft.com/web-api/data.read"],
};

export const tokenRequest: SilentRequest = {
  scopes: ["https://estatetime.onmicrosoft.com/web-api/data.read"],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};